import { render, staticRenderFns } from "./SnookerTableDialog.vue?vue&type=template&id=2ef50a35&"
import script from "./SnookerTableDialog.vue?vue&type=script&lang=js&"
export * from "./SnookerTableDialog.vue?vue&type=script&lang=js&"
import style0 from "./SnookerTableDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports